module.exports = __webpack_public_path__ + "media/images/pages/a-level/a-level-footer-image-5c47fb396074b977d84d041a6ca39d03.png";